var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoGeneralAdhesivaTransparente(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D241D5;}\n\t.st1{fill:none;stroke:#D241D5;stroke-width:0.8;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: 5.1,
    className: "st0",
    width: 9.4,
    height: 38.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 5.1,
    className: "st0",
    width: 9.4,
    height: 38.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 5.1,
    className: "st0",
    width: 9.4,
    height: 38.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.7,
    y: 5.1,
    className: "st0",
    width: 9.4,
    height: 38.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.4,5.1 38.1,5.1 24.4,23.7 14.1,23.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.2,5.1 96.9,5.1 68.5,43.6 68.5,26.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.8,25.1 14.1,25.1 27.7,43.6 38.1,43.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "133.2,2.8 127.3,9.7 138.3,23.7 148.6,23.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "137.9,25.1 148.6,25.1 133.2,45 126.9,38.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 5.1,
    className: "st0",
    width: 14.8,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 20,
    className: "st0",
    width: 9,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 35.3,
    className: "st0",
    width: 14.8,
    height: 8.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.6,19.5c0.8,0.8,1.9,1.1,3.2,1.1s2.4-0.4,3.2-1.1c0.8-0.8,1.2-1.8,1.2-3.1V6.4h3.4v9.9 c0,1.5-0.3,2.7-0.9,3.8c-0.6,1.1-1.5,1.9-2.7,2.5c-1.2,0.6-2.5,0.9-4.1,0.9c-1.6,0-3-0.3-4.1-0.9c-1.2-0.6-2.1-1.4-2.7-2.5 c-0.6-1.1-0.9-2.4-0.9-3.8V6.4h3.4v9.9C165.4,17.7,165.8,18.7,166.6,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.8,9.5c-1-0.3-1.8-0.4-2.5-0.4c-0.8,0-1.5,0.1-1.9,0.4c-0.5,0.3-0.7,0.7-0.7,1.2c0,0.5,0.2,0.9,0.5,1.2 c0.3,0.3,0.7,0.6,1.2,0.8c0.5,0.2,1.2,0.4,2,0.7c1.2,0.3,2.2,0.7,2.9,1s1.4,0.8,2,1.5c0.5,0.7,0.8,1.5,0.8,2.6c0,1-0.3,1.9-0.9,2.7 s-1.4,1.3-2.4,1.7c-1,0.4-2.2,0.6-3.5,0.6c-1.4,0-2.7-0.2-4-0.7c-1.3-0.5-2.5-1.1-3.4-2l1.4-2.7c0.9,0.8,1.9,1.4,3,1.9 c1.1,0.4,2.2,0.7,3.1,0.7c0.9,0,1.7-0.2,2.2-0.5c0.5-0.3,0.8-0.8,0.8-1.4c0-0.5-0.2-0.9-0.5-1.2s-0.7-0.6-1.3-0.8 c-0.5-0.2-1.2-0.4-2.1-0.7c-1.2-0.3-2.2-0.7-2.9-1c-0.8-0.3-1.4-0.8-1.9-1.5c-0.5-0.7-0.8-1.5-0.8-2.6c0-1,0.3-1.8,0.8-2.6 c0.5-0.7,1.3-1.3,2.3-1.7c1-0.4,2.2-0.6,3.5-0.6c1.1,0,2.3,0.2,3.4,0.5c1.1,0.3,2.1,0.8,3,1.3l-1.4,2.8 C191.7,10.2,190.8,9.8,189.8,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.2,7.3c1.4,0.8,2.6,1.8,3.4,3.1s1.2,2.8,1.2,4.4s-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.1 c-1.4,0.8-3,1.2-4.8,1.2c-1.8,0-3.4-0.4-4.8-1.2c-1.4-0.8-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.2-4.4 c0.8-1.3,2-2.4,3.4-3.1c1.4-0.8,3-1.1,4.8-1.1C207.2,6.2,208.8,6.6,210.2,7.3z M202.5,9.8c-0.9,0.5-1.7,1.2-2.2,2.1 c-0.5,0.9-0.8,1.8-0.8,2.9c0,1.1,0.3,2,0.8,2.9c0.5,0.9,1.3,1.6,2.2,2.1c0.9,0.5,1.9,0.8,3,0.8c1.1,0,2-0.3,3-0.8s1.6-1.2,2.2-2.1 c0.5-0.9,0.8-1.9,0.8-2.9c0-1.1-0.3-2-0.8-2.9c-0.5-0.9-1.3-1.6-2.2-2.1c-0.9-0.5-1.9-0.8-3-0.8C204.4,9.1,203.4,9.3,202.5,9.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.4,38.4h3v6.4c-0.9,0.7-2,1.2-3.3,1.6c-1.3,0.4-2.5,0.6-3.7,0.6c-1.7,0-3.3-0.4-4.7-1.2 c-1.4-0.8-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.3-4.4c0.8-1.3,2-2.3,3.5-3.1c1.5-0.8,3.1-1.1,4.8-1.1 c1.3,0,2.5,0.2,3.7,0.7s2.3,1,3.2,1.8l-1.9,2.4c-0.7-0.6-1.5-1.1-2.3-1.4c-0.9-0.3-1.8-0.5-2.7-0.5c-1.1,0-2.1,0.3-3.1,0.8 c-0.9,0.5-1.7,1.2-2.2,2.1c-0.5,0.9-0.8,1.8-0.8,2.9c0,1.1,0.3,2,0.8,2.9c0.5,0.9,1.3,1.6,2.2,2.1s2,0.8,3.1,0.8 c0.6,0,1.2-0.1,1.9-0.3c0.7-0.2,1.3-0.4,1.9-0.8V38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,29.9h13v2.8h-9.6v4.2h8.6v2.8h-8.6V44h9.9v2.8h-13.3V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.3,29.9h3.3v16.9h-3.2l-9.1-11.6v11.6H198V29.9h3.2l9.1,11.6V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,29.9h13v2.8h-9.6v4.2h8.6v2.8h-8.6V44h9.9v2.8H218V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.8,46.8l-3.1-5c-0.1,0-0.3,0-0.6,0h-4v5h-3.4V29.9h7.4c2.3,0,4.1,0.5,5.3,1.5c1.2,1,1.9,2.4,1.9,4.3 c0,1.3-0.3,2.4-0.9,3.4c-0.6,0.9-1.5,1.6-2.6,2.1l3.9,5.6H245.8z M238.1,39h4c1.3,0,2.3-0.3,2.9-0.8c0.7-0.5,1-1.3,1-2.4 c0-1-0.3-1.8-1-2.3c-0.7-0.5-1.7-0.8-2.9-0.8h-4V39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.1,46.8l-1.6-3.6h-8.7l-1.6,3.6h-3.5l7.8-16.9h3.5l7.7,16.9H266.1z M257.1,40.4h6.2l-3.1-7.1L257.1,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.9,29.9h3.4v14h7.6v2.9h-11V29.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoGeneralAdhesivaTransparente);
export default __webpack_public_path__ + "static/media/kive-uso-general-adhesiva-transparente.c75d7bb462d590bab01414bb5abc9c11.svg";
export { ForwardRef as ReactComponent };